// @flow
/* eslint-disable react/no-string-refs */
import React, { Component } from 'react';
import CollapsibleContainer from '@justpark/ui/src/components/CollapsibleContainer';
import Expand from '../../svg/expand.svg';
import Collapse from '../../svg/collapse.svg';
import { track } from '../../helpers/Tracking/Analytics';

import '../../../static/scss/components/accordion.scss';

type Props = {
  children: any | Array<any>,
  activeTab?: string
};

type State = {
  active: Array<number>
};

export default class Accordion extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      active: [0]
    };
  }

  componentDidMount() {
    this.forceUpdate();
  }

  toggle(index, isActive) {
    let { active } = this.state;
    active = active.slice();
    // if the list item is not active (i.e. collapsed) we want to track it
    if (!isActive) {
      track('click:additional-info:expand');
    }
    return active.includes(index)
      ? this.setState({ active: active.filter((elem) => index !== elem) })
      : this.setState({ active: active.concat([index]) });
  }

  render() {
    return (
      <div className="c-accordion">
        <ul>
          {this.props.children &&
            this.props.children.map((tab, index) => {
              const header =
                tab.props.children.filter(
                  (item) => item.type === 'header'
                )[0] || 'title';
              const content =
                tab.props.children.filter((item) => item.type === 'div')[0] ||
                'content';

              const active =
                this.state.active.includes(index) ||
                this.props.activeTab === tab.props.className;

              const className = `c-accordion-item c-accordion-item--${
                tab.props.className
              } ${active ? 'c-accordion-item--active' : ''}`;

              return (
                <li id={tab.props.className} className={className} key={index}>
                  <div
                    className="c-accordion-item__wrapper"
                    onClick={this.toggle.bind(this, index, active)}
                  >
                    <div className="c-accordion-item__header">{header}</div>
                    {active ? <Collapse /> : <Expand />}
                  </div>
                  <div className="content c-accordion-item__content">
                    <CollapsibleContainer isOpened={active}>
                      {content}
                    </CollapsibleContainer>
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

Accordion.defaultProps = {
  activeTab: ''
};
